import styled from 'styled-components'

export const DraftCourse = styled.div`
  color: #757575;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  position: absolute;
  bottom: 15px;
  width: 100%;
  svg {
    margin-right: 8px;
  }
`

export const InactiveCardSection = styled.div<{ $inactive?: boolean }>`
  opacity: ${({ $inactive }) => ($inactive ? 0.56 : 1)};
`

export const DraftCourseTooltip = styled.div`
  font-family: Roboto;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  background-color: #363636;
  margin: -6px -8px;
  border-radius: 5px;
  padding: 5px;
`
